import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './Landing.css';

let headerImg = null;
let footerImg = null;
try { headerImg = require('../assets/images/pringles_top.png'); } catch {}
try { footerImg = require('../assets/images/pringles_bottom.png'); } catch {}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Landing = ({ onShowTerminos }) => {
  const [email, setEmail] = useState('');
  const [emailTouched, setEmailTouched] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const navigate = useNavigate();
  const { cadena } = useParams();

  const emailValid = EMAIL_REGEX.test(email.trim());

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (!emailTouched) setEmailTouched(true);
  };

  const handleContinuar = () => {
    if (!termsAccepted || !emailValid) return;
    sessionStorage.setItem('userAuthData', JSON.stringify({ email: email.trim() }));
    if (cadena) sessionStorage.setItem('cadena', cadena);
    navigate('/form');
  };

  return (
    <div className="landing-container">
      {headerImg && <img src={headerImg} alt="Destapá el fútbol con Pringoools" className="landing-top-img" />}

      <div className="landing-middle">
        <p className="landing-vigencia">VIGENCIA PROMO: 25 de junio de 2026 hasta el 31 de julio de 2026.</p>
        <input
          type="email"
          value={email}
          onChange={handleEmailChange}
          onBlur={() => setEmailTouched(true)}
          placeholder="Ingresá tu e-mail"
          className={`landing-email-input${emailTouched && !emailValid && email ? ' landing-email-error' : ''}`}
        />
        {emailTouched && !emailValid && email && (
          <span className="landing-email-error-msg">Ingresá un e-mail válido (ej: nombre@correo.com)</span>
        )}

        <div className="landing-terms-row">
          <input
            type="checkbox"
            id="terms"
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
            className="landing-checkbox"
          />
          <label htmlFor="terms" className="landing-terms-label">
            ACEPTO{' '}
            <span className="landing-terms-link" onClick={onShowTerminos}>
              TÉRMINOS Y CONDICIONES
            </span>
          </label>
        </div>

        <button
          className="landing-continuar-btn"
          onClick={handleContinuar}
          disabled={!termsAccepted || !emailValid}
        >
          CONTINUAR
        </button>

        <p className="landing-tyc-note">*Aplica TyC</p>
        <p className="landing-legal-text">
          *Llevate un Kit Pringles® abonando ARS$100 al momento de reclamar. Promoción válida del 25/06/2026 al 31/07/2026 en todo el territorio de la República Argentina. Sin obligación de compra. Mayores de 18 años. Stock de Kits: 210. Bases y condiciones completas en el QR adjunto. Organiza Open 25. Auspicia Establecimiento Las Marías SACIFA. *Aplica para puntos de venta Localidad CABA.
        </p>
      </div>

      {footerImg && <img src={footerImg} alt="Pasos para participar" className="landing-bottom-img" />}
    </div>
  );
};

export default Landing;
